import { Box, Grid, MenuItem, TextField } from "@mui/material"
import type React from "react"
import { useEffect } from "react"
import { useForm } from "react-hook-form"

interface FilterOption {
  label: string
  value: string
}

interface FilterFormData {
  tags: string
  program: string
  category: string
  priceMin: string
  priceMax: string
  tag: string
}

interface MenuOffersFilterProps {
  categoriesOptions: FilterOption[]
  programsOptions: FilterOption[]
  tagsOptions: FilterOption[]
  onFilterChange: (filters: {
    category: string
    tag: string
    program: string
    priceMin: string
    priceMax: string
  }) => void
}

const MenuOffersFilter: React.FC<MenuOffersFilterProps> = ({
  categoriesOptions,
  programsOptions,
  tagsOptions,
  onFilterChange,
}) => {
  const { register, watch, setValue } = useForm<FilterFormData>({
    defaultValues: {
      tags: "",
      program: "",
      category: "",
      priceMin: "",
      priceMax: "",
    },
  })

  const tag = watch("tag")
  const program = watch("program")
  const category = watch("category")
  const priceMin = watch("priceMin")
  const priceMax = watch("priceMax")

  useEffect(() => {
    setValue("tag", "")
    setValue("program", "")
  }, [category, setValue])

  useEffect(() => {
    onFilterChange({ category, tag, program, priceMin, priceMax })
    // eslint-disable-next-line
  }, [category, tag, program, priceMin, priceMax])

  return (
    <form>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid size={4}>
            <TextField
              select
              fullWidth
              label="Categoria"
              defaultValue=""
              {...register("category")}
            >
              <MenuItem value="">Categoria</MenuItem>
              {categoriesOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid size={4}>
            <TextField
              select
              fullWidth
              label="Tag"
              defaultValue=""
              {...register("tag")}
            >
              <MenuItem value="">Tag</MenuItem>
              {tagsOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid size={4}>
            <TextField
              select
              fullWidth
              label="Programa"
              defaultValue=""
              {...register("program")}
            >
              <MenuItem value="">Programa</MenuItem>
              {programsOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid size={6}>
            <TextField
              fullWidth
              label="Valor min"
              placeholder="Valor min"
              type="number"
              {...register("priceMin")}
            />{" "}
          </Grid>
          <Grid size={6}>
            <TextField
              fullWidth
              label="Valor max"
              placeholder="Valor max"
              type="number"
              {...register("priceMax")}
            />{" "}
          </Grid>
        </Grid>
      </Box>
    </form>
  )
}

export default MenuOffersFilter
